import React from "react";
import { CBLAnimationNGContext } from "../CBLAnimationNGContext";

export const useCBLAnimationNG = () => {
	return React.useContext(CBLAnimationNGContext);
};
